import { Paper, LoadingOverlay, Group, Text, Button, Table, Badge, ActionIcon } from '@mantine/core';
import { IconPlus, IconEdit, IconTrash } from '@tabler/icons-react';

export default function RolesSettingsSection({
  loading,
  activeTab,
  rolesList,
  fetchRoles,
  openNewRole,
  openEditRole,
  handleDeleteRole,
}) {
  return (
    <Paper withBorder p="md" radius="md" mt="xs" pos="relative">
      <LoadingOverlay visible={loading && activeTab === 'roles'} overlayProps={{ radius: 'sm', blur: 2 }} />

      <Group justify="space-between" mb="md">
        <Text fw={700}>Sistem Rolleri ve Yetkiler</Text>
        <Group>
          <Button size="xs" variant="light" onClick={fetchRoles}>
            Yenile
          </Button>
          <Button size="xs" color="orange" leftSection={<IconPlus size={14} />} onClick={openNewRole}>
            Yeni Rol Ekle
          </Button>
        </Group>
      </Group>

      <Table striped highlightOnHover withTableBorder>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Rol Adı (Key)</Table.Th>
            <Table.Th>Açıklama</Table.Th>
            <Table.Th style={{ textAlign: 'right' }}>İşlem</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {rolesList.map((role) => (
            <Table.Tr key={role.id}>
              <Table.Td>
                <Badge color={role.name === 'admin' ? 'red' : 'blue'}>{role.name}</Badge>
              </Table.Td>
              <Table.Td>{role.description || '-'}</Table.Td>
              <Table.Td style={{ textAlign: 'right' }}>
                <Group gap="xs" justify="flex-end">
                  <ActionIcon color="blue" variant="subtle" onClick={() => openEditRole(role)}>
                    <IconEdit size={16} />
                  </ActionIcon>
                  {role.name !== 'admin' && (
                    <ActionIcon color="red" variant="subtle" onClick={() => handleDeleteRole(role.id)}>
                      <IconTrash size={16} />
                    </ActionIcon>
                  )}
                </Group>
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Paper>
  );
}